import { createTheme } from '@mui/material/styles';

const DMS_PALETTE_DARK = {
  deepBlue: '#0A1628',
  blue: '#1565C0',
  green: '#00C853',
  yellow: '#FFD600',
  black: '#050D1A',
  white: '#FFFFFF',
  surface: '#0F1E35',
  border: '#1A2E4A',
  textSecondary: '#A8BED8',
  textPrimary: '#E8F4FD',
};

const DMS_PALETTE_LIGHT = {
  deepBlue: '#ffffff',
  blue: '#0d47a1',
  green: '#2e7d32',
  yellow: '#f9a825',
  black: '#f4f6f9',
  white: '#1a237e',
  surface: '#ffffff',
  border: '#dce3ec',
  textSecondary: '#546e7a',
  textPrimary: '#1a237e',
};

/** @deprecated Use getDmsPalette(mode) or useDmsPalette() */
export const MP = DMS_PALETTE_DARK;

export const getDmsPalette = (mode = 'dark') =>
  mode === 'light' ? DMS_PALETTE_LIGHT : DMS_PALETTE_DARK;

export const dmsTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: MP.blue },
    secondary: { main: MP.green },
    background: { default: MP.black, paper: MP.deepBlue },
    text: { primary: MP.white, secondary: MP.textSecondary },
    success: { main: MP.green },
    warning: { main: MP.yellow },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  components: {
    MuiDrawer: { styleOverrides: { paper: { backgroundColor: MP.deepBlue, borderRight: `1px solid ${MP.border}` } } },
    MuiAppBar: { styleOverrides: { root: { backgroundColor: MP.deepBlue, borderBottom: `1px solid ${MP.border}` } } },
    MuiCard: { styleOverrides: { root: { backgroundColor: MP.surface, border: `1px solid ${MP.border}` } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
  },
});
